// extracted by mini-css-extract-plugin
export var content = "_db-3";
export var list = "_db-4";
export var settingsContent = "_db-7";
export var settingsPanel = "_db-8";
export var state = "_db-6";
export var triggerBadge = "_db-2";
export var triggerButton = "_db-1";
export var triggerShell = "_db-0";
export var unreadDot = "_db-5";